import { type ReactNode } from 'react'
import styles from './MobileEntityList.module.css'

type MobileEntityListProps = {
  children: ReactNode
  className?: string
  empty?: ReactNode
  toolbar?: ReactNode
}

export const MobileEntityList = ({
  children,
  className,
  empty,
  toolbar
}: MobileEntityListProps) => (
  <div className={[styles.root, className].filter(Boolean).join(' ')}>
    {toolbar && <div className={styles.toolbar}>{toolbar}</div>}
    <div className={styles.items}>
      {children}
    </div>
    {empty}
  </div>
)
